import {Params} from '@feathersjs/feathers'

import {MaterialConfig} from '../../types'

import * as feathersService from '../feathers'

export const RESOURCE = 'materialConfig'

export const get = async (params?: Params) => feathersService.find<MaterialConfig>(RESOURCE, params)

export const getByDefaultOrder = async () => {
  const params = {
    query: {
      $modify: 'defaultOrder',
    },
  }

  return get(params)
}
